import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  background: {
    backgroundColor: '#fff',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/StartPage/styles.js